import { Action } from '@ngrx/store';


export enum NavigatorActionTypes {
	NavigatorBsResChanged = '[App Component] Navigator Bootstrap Resolution Changed'
}

export class NavigatorBsResChanged implements Action {
	readonly type: string = NavigatorActionTypes.NavigatorBsResChanged;
	constructor( public payload: { bsRes: string } )  {
	}
}

export type NavigatorActions = NavigatorBsResChanged;